import { TreeService } from 'business/services/TreeService';
import { BaseTreeDataSupplier } from './BaseTreeDataSupplier';

class WizardReviewTreeDataSupplier implements BaseTreeDataSupplier {
  async getTreeNodes(id: any) {
    const ser: TreeService = new TreeService();
    const children = await ser.getWizardProteinTreeNodesService(id, true);

    if (children === null) {
      return null;
    }

    return children;
  }
}

export default WizardReviewTreeDataSupplier;
